<app-page-header-bar dialog justify-content="center">
	{{pageHeading()}}
</app-page-header-bar>

<mat-dialog-content class="custom-scrollbar">

	<section class="relationship-details" aria-labelledby="relationship-details-title">
		<h2 id="relationship-details-title">Relationship Details</h2>

		<form id="relationship-details" (ngSubmit)="saveRelationship()" [formGroup]="form">

			@let firstName = form.controls.firstName;
			<mat-form-field appearance="outline" floatLabel="auto">
				<mat-label>First Name</mat-label>
				<input matInput formControlName="firstName" required>
				@if (firstName.hasError('required')) {
					<mat-error>First name is required</mat-error>
				} @else if (firstName.hasError('maxlength')) {
					<mat-error>
						Over {{firstName.getError('maxlength').requiredLength}}
						character limit
						({{firstName.getError('maxlength').actualLength - firstName.getError('maxlength').requiredLength}})
					</mat-error>
				}
			</mat-form-field>

			@let lastName = form.controls.lastName;
			<mat-form-field appearance="outline" floatLabel="auto">
				<mat-label>Last Name</mat-label>
				<input matInput formControlName="lastName">
				 @if (lastName.hasError('maxlength')) {
					<mat-error>
						Over {{lastName.getError('maxlength').requiredLength}}
						character limit
						({{lastName.getError('maxlength').actualLength - lastName.getError('maxlength').requiredLength}})
					</mat-error>
				}
			</mat-form-field>

			<mat-form-field class="interaction-goal" hintLabel="How often would you like to stay in contact?" appearance="outline" floatLabel="auto">
				<mat-label>Interaction Goal</mat-label>
				<select formControlName="interactionRateGoal" matNativeControl>
					<option [value]="InteractionRates.EveryDay">{{InteractionRates.EveryDay}}</option>
					<option [value]="InteractionRates.EveryWeek">{{InteractionRates.EveryWeek}}</option>
					<option [value]="InteractionRates.EveryTwoWeeks">{{InteractionRates.EveryTwoWeeks}}</option>
					<option [value]="InteractionRates.EveryMonth">{{InteractionRates.EveryMonth}}</option>
					<option [value]="InteractionRates.EveryTwoMonths">{{InteractionRates.EveryTwoMonths}}</option>
					<option [value]="InteractionRates.EverySixMonths">{{InteractionRates.EverySixMonths}}</option>
					<option [value]="InteractionRates.EveryYear">{{InteractionRates.EveryYear}}</option>
				</select>
			</mat-form-field>

			@let notes = form.controls.notes;
			<mat-form-field class="notes" appearance="outline" floatLabel="auto">
				<mat-label>Notes</mat-label>
				<textarea matInput formControlName="notes" rows="3"></textarea>
				@if (notes.hasError('maxlength')) {
					<mat-error>
						Over {{notes.getError('maxlength').requiredLength}}
						character limit (by
						{{notes.getError('maxlength').actualLength - notes.getError('maxlength').requiredLength}})
					</mat-error>
				}
			</mat-form-field>
		</form>
	</section>

	<section class="interactions" aria-labelledby="interactions-title">
		<h2 id="interactions-title">
			Interactions
			<button (click)="addInteraction()" mat-button>Add Interaction</button>
		</h2>

			<p>
				@if (form.controls.interactions.value.length) {
					Here you can view all of your most recent interactions{{(firstName.value) ? ` with ${firstName.value}` : ''}}.<br />
				} @else {
					Once you add interactions, they will appear here.
				}
			</p>

		<div class="interactions-container">
			@for (interaction of interactions; track interaction._id || interaction.date) {
				<app-card
					[interaction]="interaction"
					(edit-interaction)="editInteraction($event)"
					(delete-interaction)="deleteInteraction($event)"
					collapsible
				>
					<app-interaction-card-content [interaction]="interaction" />
				</app-card>
			}
		</div>
	</section>
</mat-dialog-content>

<mat-dialog-actions>
		@if (!wasRelationshipModified()) {
			<button (click)="closeDialog()" mat-button>Done</button>
		}
		@else {
			<button [mat-dialog-close]="{ wasCancelled: true }" mat-button>Cancel</button>
			<button (click)="saveRelationship()" mat-button>Save</button>
		}
</mat-dialog-actions>
